import { Button } from '@sainsburys-tech/fable'
import React, { useState } from 'react'

interface IProductionPlanningButtonProps {
  testid?: string
  children?: React.ReactNode
  isFullWidth?: boolean
  handler: () => Promise<any> | void
  variant?: 'primary' | 'secondary' | 'tertiary'
}

const ProductionPlanningButton = (props: IProductionPlanningButtonProps) => {
  const [disabled, setDisabled] = useState(false)

  // handle button click
  const handleClick = () => {
    const handlerResult = props.handler()

    // check if the handler returns a promise
    if (handlerResult && typeof handlerResult.then === 'function') {
      // Disable button
      setDisabled(true)

      // re-enable button after promise resolves or rejects
      handlerResult
        .then(() => setDisabled(false))
        .catch(() => setDisabled(false))
    }
  }

  // render button
  return (
    <Button
      variant={props.variant || 'primary'}
      isFullWidth={props.isFullWidth}
      disabled={disabled}
      onClick={handleClick}
      role='button'
      testid={props.testid}
      type='button'
    >
      {props.children}
    </Button>
  )
}

export default ProductionPlanningButton
